import { render, staticRenderFns } from "./LayoutCenteredSidebar.vue?vue&type=template&id=686ea30a&scoped=true&"
import script from "./LayoutCenteredSidebar.vue?vue&type=script&lang=js&"
export * from "./LayoutCenteredSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCenteredSidebar.vue?vue&type=style&index=0&id=686ea30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ea30a",
  null
  
)

export default component.exports